const Tutorial = () => import(/* webpackChunkName: "support" */ '@/components/support/tutorial')
export default {
  name: 'tutorialVideoclips',
  path: 'tutorialVideoclips',
  redirect: '/tutorialVideoclips/index',
  meta: {label: 'tutorialVideoclips'},
  component: {
    render (c) { return c('router-view') }
  },
  children: [

    {
      path: 'index',
      meta: {label: 'Index'},
      component: Tutorial,
      props: true
    }
  ]
}
